<template>
  <div class="form_container combo_1">
    <p class="text_lg tal_c">{{ $t("msg.change_password") }}</p>

    <div class="form_block combo_1">
      <input
        class="form_white_border regular_input"
        type="password"
        id="password"
        :placeholder="$t('msg.password_create')"
        v-model="changePasswordForm.password"
        :style="errorInputStyle.password"
        @keyup="onChangeRemoveError(changePasswordForm, 'password')"
      />
      <span class="help is-danger" v-show="hasError.password">{{$tc(`msg.${errorMsg.password}`,1)}}</span>
      <span>{{$tc(`msg.password_requirements`,1)}}</span>
    </div>
    <div class="form_block combo_1">
      <input
        class="form_white_border regular_input"
        type="password"
        id="confirm_password"
        :style="errorInputStyle.passwordConfirmation"
        :placeholder="$t('msg.confirm_password')"
        v-model="changePasswordForm.passwordConfirmation"
        @keyup="onChangeRemoveError(changePasswordForm, 'passwordConfirmation')"
      />
      <span
        class="help is-danger"
        v-show="hasError.passwordConfirmation"
      >{{$tc(`msg.${errorMsg.passwordConfirmation}`,1)}}</span>
    </div>

    <div class="form_block combo_1">
      <input
        type="submit"
        class="regular_submit"
        :placeholder="$t('msg.continue')"
        @click="submitChangePassword()"
      />
    </div>
  </div>
</template>

<script>
class ChangePasswordFields {
  constructor() {
    this.password = "";
    this.passwordConfirmation = "";
    this.pinHash = "";
  }
}

export default {
  created() {
    this.pinhash = this.$route.params.pinhash;
  },
  mounted() {
    this.setValidationFields(ChangePasswordFields);
    console.log("pinhash:", this.pinhash);
  },
  data: () => ({
    changePasswordForm: new ChangePasswordFields(),
    pinhash: ""
  }),
  methods: {
    submitChangePassword() {
      const form = this.changePasswordForm;
      this.showOrHideError("password", this.validatePassword(form.password));
      this.showOrHideError(
        "passwordConfirmation",
        form.passwordConfirmation && form.passwordConfirmation === form.password
      );
      form.pinHash = this.pinhash;
      this.checkIfFormHasErrorsAndSubmit(
        form,
        this.putChangePasswordConfirm,
        this.afterSubmitSuccess,
        this.afterSubmitError
      );
    },
    putChangePasswordConfirm(form) {
      return this.$store.dispatch("putRecoverPasswordConfirm", form);
    },
    afterSubmitSuccess() {
      this.notifyDefault(
        this.$t("msg.password_changed"),
        "alert_success",
        5000
      );
      this.$router.push("login");
    },
    afterSubmitError(error) {
      this.notifyDanger(error);
    }
  },
  computed: {}
};
</script>


// WEBPACK FOOTER //
// src/views/public/ChangePassword.vue